import { type PropsWithChildren } from 'react';

import styles from './Section.module.css';

export const SectionHeading = ({ children }: PropsWithChildren) => {
  return <div className={styles.textWrapper}>{children}</div>;
};

export type SectionProps = {
  className?: string;
  testId?: string;
};

export const Section = ({
  children,
  className,
  testId
}: PropsWithChildren<SectionProps>) => {
  return (
    <section className={`${styles.section} ${className}`} data-testid={testId}>
			{children}
		</section>);

};